import { AppState } from "../state.model";

export const getAppointmentState = (state: AppState) => state.appointment;

export const getSharedState = (state: AppState) => state.shared;